import { DocumentEditorPage } from '@jarvis/platform-ui';

export function SpreadsheetEditorPage() {
  return <DocumentEditorPage mode="edit" kind="spreadsheet" filesLinkTo="/files" filesLinkLabel="Files" />;
}
